import React, { useMemo, useState } from "react";
import styled from "@emotion/styled";
import { useNavigate } from "@core/routing/use-navigate";
import { useFormatPatients } from "@domain/patient/hooks/use-patients";
import { useGenderIcon } from "@domain/patient/hooks/use-gender-icon";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { PatientProgramProfile } from "@domain/program/patient-program";

interface PatientButtonProps {
	patient: PatientProgramProfile;
}

export const PatientButton: React.FC<PatientButtonProps> = ({ patient }) => {
	const navigate = useNavigate();
	const { getGenderIcon } = useGenderIcon();
	const { formatPatientName } = useFormatPatients();
	const [isHovering, setIsHovering] = useState(false);

	const GenderIcon = useMemo(() => getGenderIcon(patient, isHovering), [getGenderIcon, patient, isHovering]);

	return (
		<Container
			onClick={e => {
				e.stopPropagation();
				navigate(RoutesPath.PatientDetails, {
					route: { patientId: patient.id },
					query: { active: TabPatientDetails.PROGRESS_TAB },
				});
			}}
			onMouseEnter={() => {
				setIsHovering(true);
			}}
			onMouseLeave={() => {
				setIsHovering(false);
			}}
		>
			<GenderIcon width={20} height={20} />
			<div className="p-size-xs-semi-bold">{formatPatientName(patient)}</div>
		</Container>
	);
};

const Container = styled.div`
	${row("XS", "flexstart", "center")};
	padding: 4px 8px 4px 4px;
	border-radius: 4px;
	color: ${colors.black};

	&:hover {
		background-color: ${colors.primaryBackground};
		color: ${colors.primary};
	}
`;
